import React from "react";
import {TrainingContent} from "../../common/webapicall";

interface Props {
	trainingContent: TrainingContent;
}

const TrainingContentCard: React.FC<Props> = ({trainingContent}: Props) => {
	return (
		<div className="cih-training-content-card">
			<a href={trainingContent.url} target="_blank" rel="noopener noreferrer">
				<img src={trainingContent.thumbnailUrl} alt={trainingContent.title} />
				<div className="cih-training-content-container">
					<div className="cih-card-header">
						<div className="cih-card-type">{trainingContent.taxonomyName}</div>
					</div>
					<div className="cih-card-title cih-line-clamp clamp-2 cih-mb-05">{trainingContent.title}</div>
					<div title={trainingContent.ingress}>{trainingContent.ingress && <p className="cih-line-clamp clamp-3">{trainingContent.ingress}</p>}</div>
				</div>
			</a>
		</div>
	);
};

export default TrainingContentCard;
